export class SeoLink {
  title: any;
  link: string;

  constructor(data = {}) {
    this.title = data['title'];
    this.link = data['link'] && decodeURI(data['link']); // `routerLink` re-encodes URLs...
  }
}
